<template>
  <div id="pricing-ts">
    <div class="container">
      <div>
        <div class="row justify-content-center">
          <div class="mr-md-5 mr-0">
            <div class="custom-card premium">
              <div class="plan-name white font-avenir">Download CV</div>
              <div class="plan-price-premium white">
                <div class="rm">RM</div>
                <div class="user font-avenir white">Top up as you go</div>
                <span class="font-avenir">20</span>/ CV*
              </div>
              <div class="plan-features">
                <div class="magenta font-avenir white">What's Included</div>

                <div class="lists mt-2" v-for="data in employeeList" :key="data.title">
                  <div class="title font-avenir white">{{ data.title }}</div>
                  <ul>
                    <li v-for="list in data.lists" :key="list" class="d-flex align-items-center white">
                      <i class="fas fa-check"></i>
                      {{ list }}
                    </li>
                  </ul>
                </div>
              </div>

              <div class="cta">
                <a :href="accountCreationLink">Create Account</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      employeeList: [
        {
          title: 'Talent CV Access',
          lists: [
            "Download talent's CV",
            'Post A Job',
            'Talent matching by algorithm',
          ],
        },
      ],
      freelancerList: [
        {
          title: 'Recruitment',
          lists: [
            'Post A Gig',
            'Talent matching by algorithm',
            'Profile screening by talent coordinator',
            'Interview scheduled by talent coordinator',
            'Talent coordinator assist to close offer with candidate',
            'Purchase first 100 hours',
            'Top-up next 100 hours as needed',
          ],
        },
      ],
      contractorList: [
        {
          title: 'Recruitment',
          lists: [
            'Post A Job',
            'Talent matching by algorithm',
            'Profile screening by talent coordinator',
            'Interview scheduled by talent coordinator',
            'Talent coordinator assist to close offer with candidate',
            'Pay us monthly, we pay contractor',
          ],
        },
        {
          title: 'Additional Services',
          lists: [
            'Visa for expat talent',
          ],
        },
      ],
    }
  },

  computed: {
    accountCreationLink() {
      return route('auth-broker.registration', { email: '', success_redirect_url: route('tribesuite.onboarding') })
    },
  },
}
</script>

<style lang="scss" scoped>
#pricing-ts {
  .white {
    color: white !important;
  }

  .custom-card {
    width: 312px;
    height: 100% !important;
    position: relative;
    padding: 28px 26px 21px;
    min-height: 518.2px;

    &.premium {
      .plan-price-premium {
        span {
          font-size: 64px;
        }
      }
    }

    .plan-price,
    .plan-price-premium {
      .full-time {
        font-size: 64px;
      }

      .percentage {
        font-size: 20px;
        top: 0;
        left: 80px;
        font-weight: normal;
      }

      .annual-salary {
        bottom: -5px;
        left: 0;
        font-size: 20px;
        font-weight: 200;
      }
    }

    .plan-name {
      font-size: 22px;
      margin-bottom: 16px;
    }

    .plan-price,
    .plan-price-premium {
      position: relative;
      margin-bottom: 16px;

      span {
        margin-left: 32px;
      }

      .rm {
        position: absolute;
        top: 0;
        font-size: 20px;
        letter-spacing: 0;
        line-height: 27px;
      }

      .user {
        position: absolute;
        bottom: 0;
        color: #222227;
        font-size: 18px;
        font-weight: 300;
        letter-spacing: 0;
        line-height: 28px;
      }
    }

    .plan-features {
      div {
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 36px;
      }

      .magenta {
        color: #ff375e;
      }

      .lists {
        .title {
          font-size: 22px;
          font-weight: 600;
          letter-spacing: 0;
          line-height: 36px;
          margin-bottom: 10px;
        }

        ul {
          padding-left: 0;

          li {
            margin-bottom: 8px;

            .fas {
              flex-shrink: 0;
              margin-right: 14px;
              background: red;
              color: white;
              height: 20px;
              width: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
              font-size: 10px;
            }

            // list-style-image: url("~/images/check.svg");
            color: #606060;

            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 24px;
          }
        }
      }
    }

    .cta {
      margin-top: 80px;

      a {
        font-family: "Open Sans", sans-serif;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0 26px 21px;
        width: auto;
      }
    }
  }
}
</style>
